import { render } from "./AlarmTypeBadge.vue?vue&type=template&id=340dd3e4"
import script from "./AlarmTypeBadge.vue?vue&type=script&lang=js"
export * from "./AlarmTypeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__